import uniq from 'lodash/uniq';

import {MetricType} from 'common/query-builder/query-block/constants';
import {SPECIAL_EVENTS} from 'common/report/constants';
import {renameEvent} from 'common/report/util/events';

import {hasGroupByCohort, hasGroupByUser, isBehaviorShowClause} from '../models/utils';
import {InsightsBookmarkParams} from './types';

export function getRetentionAttributionItems(bookmarkParams: InsightsBookmarkParams) {
  const {show: showClauses, group} = bookmarkParams.sections;
  if (
    showClauses.length === 1 &&
    isBehaviorShowClause(showClauses[0]) &&
    showClauses[0].behavior.type === MetricType.Retention &&
    group.length > 0 &&
    !hasGroupByCohort(group) &&
    !hasGroupByUser(group)
  ) {
    const {behaviors} = showClauses[0].behavior;
    const {retentionSegmentationEvent} = showClauses[0].measurement;
    const events = uniq([
      behaviors?.[0]?.name || SPECIAL_EVENTS.ANY_EVENT,
      behaviors?.[1]?.name || SPECIAL_EVENTS.ANY_EVENT,
    ]);
    return events.map((event, index) => ({
      value: event,
      index: String(index),
      label: renameEvent(event),
      isSelected: event === retentionSegmentationEvent,
    }));
  }
  return null;
}
